import React from "react";

interface CardProps {
  children: React.ReactNode;
  className?: string;
  hover?: boolean;
}

export const Card: React.FC<CardProps> = ({
  children,
  className = "",
  hover = false,
}) => {
  const hoverClasses = hover
    ? "hover:shadow-xl transition-all duration-300 transform hover:scale-[1.01]"
    : "";

  return (
    <div
      className={`bg-white dark:bg-slate-800 rounded-2xl shadow-medium border border-gray-100 dark:border-slate-700 ${hoverClasses} ${className}`}
    >
      {children}
    </div>
  );
};
